import { render, staticRenderFns } from "./AutoEvaluationForm.vue?vue&type=template&id=a33d3040&scoped=true&"
import script from "./AutoEvaluationForm.vue?vue&type=script&lang=js&"
export * from "./AutoEvaluationForm.vue?vue&type=script&lang=js&"
import style0 from "./AutoEvaluationForm.vue?vue&type=style&index=0&id=a33d3040&lang=scss&scoped=true&"
import style1 from "./AutoEvaluationForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33d3040",
  null
  
)

export default component.exports